import { render, staticRenderFns } from "./PosBind.vue?vue&type=template&id=fbd19f08&"
import script from "./PosBind.vue?vue&type=script&lang=js&"
export * from "./PosBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports